import { useCallback, useState } from 'react';
import mapValues from 'lodash/mapValues';
import { NewTableFilters } from '@common/components/new-table';

type TableFiltersControllerProps = {
  getFilters: () => Promise<Record<string, string>>;
};

export const useTableFiltersController = (props: TableFiltersControllerProps) => {
  const { getFilters } = props;
  const [filters, setFilters] = useState<NewTableFilters['operators'] | undefined>();

  const initializeFilters = useCallback(async () => {
    const tableFilters = await getFilters();
    const filtersProcessed = mapValues(tableFilters, (filterName) => {
      let isValidValue = undefined;

      if (filterName === 'is blank' || filterName === 'is not blank') {
        isValidValue = (value: any) => ['', null, undefined].includes(value);
      }

      return {
        name: filterName,
        isValidValue,
      };
    });

    setFilters(filtersProcessed);
  }, []);

  return {
    initializeFilters,
    filters,
  };
};